import { Box } from '@mantine/core';
import { ClientSelect } from 'views/UserSearch/components/ClientSelect';
import { useAiCoachAssistantStore } from 'store/aiCoachAssistantStore';
import { useUserPickerStyles } from './UserPicker.styles';

export const UserPicker = () => {
  const { classes } = useUserPickerStyles();
  const selectedUserId = useAiCoachAssistantStore((s) => s.selectedUserId);
  const selectUser = useAiCoachAssistantStore((s) => s.selectUser);

  return (
    <Box className={classes.wrapper}>
      <ClientSelect
        placeholder="Select a user..."
        size="xs"
        value={selectedUserId}
        showSubscriptionStatus
        showTherapyStatus
        onChange={(option) => {
          selectUser(option?.value.userId ?? null);
        }}
      />
    </Box>
  );
};
